import type { SxProps, Theme } from "@mui/material/styles";

/** Container do grupo de toggles em formulário (modal), adaptado do padrão Cards/Tabela. */
export const patientFinderToggleWrapperSx: SxProps<Theme> = {
  display: "inline-flex",
  width: "fit-content",
  maxWidth: "100%",
  alignSelf: "flex-start",
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
  p: 0.25,
  bgcolor: "background.paper",
};

/** Estilo do ToggleButtonGroup para labels longos e mobile. */
export const patientFinderToggleGroupSx: SxProps<Theme> = {
  flexWrap: "wrap",
  width: "auto",
  minHeight: 36,
  "& .MuiToggleButton-root": {
    textTransform: "none",
    px: 1.5,
    py: 0.75,
    border: "none",
    borderRadius: 2,
    color: "text.secondary",
    backgroundColor: "transparent",
    whiteSpace: "normal",
    lineHeight: 1.2,
    flex: "0 1 auto",
    minWidth: "auto",
  },
  "& .MuiToggleButton-root.Mui-selected": {
    color: "primary.main",
    backgroundColor: "action.hover",
    fontWeight: 600,
  },
};

/** Largura mínima para labels "Idade mínima" / "Idade máxima" sem ellipsis. */
export const patientFinderAgeFieldMinWidth = 168;

/** Paper padrão dos blocos de filtro do patient finder. */
export const patientFinderFilterCardSx: SxProps<Theme> = {
  p: 1.5,
  borderRadius: 2,
  bgcolor: "background.paper",
};
